import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import Tooltip from '@jimmyboys/liita-ui/dist/components/Tooltip'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'

import { REQUESTED_APPROVED_STATES } from 'components/HFInputs/HFMedicalActsProtocol'

import styles from '../widgets.module.sass'

const PHYSIOTHERAPY_CODE = '90.99.00.01'

const MedicalActsProtocols = (props) => {
	const { data } = props
	const {
		medicalActProcessProtocols,
		providerEntities,
		medicalActs,
		requisitions,
	} = data
	const { i18n } = useGlobal()

	return medicalActProcessProtocols?.length ? (
		<>
			<HStack
				className={styles['protocol-line']}
				columns={[3, 3, 1]}
				gap='xsmall'
				justify='space-between'
			>
				<small>
					<strong>{i18n`Medical Acts`}</strong>
				</small>
				<small>
					<strong>{i18n`Provider`}</strong>
				</small>
				<small>
					<strong>{i18n`Qtd.`}</strong>
				</small>
			</HStack>
			{(medicalActProcessProtocols || []).map(
				({ serviceProviderId, medicalActId, quantity }, key) => {
					const [medicalActCode, ...medicalActStringsList] =
						medicalActs[medicalActId]?.split(' ')
					const medicalAct = medicalActStringsList.join(' ')

					let totalRequisitionsForMedicalAct = 0

					if (medicalActCode === PHYSIOTHERAPY_CODE) {
						totalRequisitionsForMedicalAct = requisitions.reduce(
							(acc, r) => {
								if (
									!REQUESTED_APPROVED_STATES.includes(
										r.status?.id
									)
								) {
									return acc
								}

								const reqMedicalAct = r.medicalActs?.find(
									(ma) => {
										return ma.code === PHYSIOTHERAPY_CODE
									}
								)

								if (!reqMedicalAct) {
									return acc
								}

								acc +=
									reqMedicalAct?.executedQuantity ||
									reqMedicalAct?.approvedQuantity

								return acc
							},
							0
						)
					} else {
						totalRequisitionsForMedicalAct =
							requisitions?.filter((r) => {
								const reqMedicalAct = r.medicalActs?.find(
									(ma) => {
										return ma.code === medicalActCode
									}
								)

								if (
									!reqMedicalAct ||
									reqMedicalAct?.approvedQuantity === 0 ||
									!REQUESTED_APPROVED_STATES.includes(
										r.status?.id
									)
								) {
									return false
								}

								return true
							}).length ?? 0
					}

					return (
						<HStack
							key={key}
							className={styles['protocol-line']}
							columns={[3, 3, 1]}
							gap='xsmall'
							justify='space-between'
						>
							<VStack>
								<small>
									<strong>{medicalActCode}</strong>
								</small>
								<Tooltip text={medicalAct || ''} delay={0}>
									<small
										className={
											styles['medical-act-description']
										}
									>
										{medicalAct}
									</small>
								</Tooltip>
							</VStack>
							<small>
								{providerEntities[serviceProviderId] ??
									i18n`None`}
							</small>
							<small>
								{totalRequisitionsForMedicalAct}/{quantity}
							</small>
						</HStack>
					)
				}
			)}
		</>
	) : (
		<Widget className={styles['centered']} justify='center'>
			<small>
				<strong>{i18n`There are no medical act protocols for the process.`}</strong>
			</small>
		</Widget>
	)
}

export default MedicalActsProtocols
